module.exports = __webpack_public_path__ + "media/images/pc/banner/mitsubachi_side-bd5b09fdd710e9e6dfd32347a9dad856.png";